/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Link_Web_HelperInputs */

const en_dialog_link_web_helper = /** @type {(inputs: Dialog_Link_Web_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Need to upload a file instead? Use the "Upload a document" option from the sidebar.`)
};

const es_dialog_link_web_helper = /** @type {(inputs: Dialog_Link_Web_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Necesitas subir un archivo? Usa la opción "Subir un documento" de la barra lateral.`)
};

/**
* | output |
* | --- |
* | "Need to upload a file instead? Use the \"Upload a document\" option from the sidebar." |
*
* @param {Dialog_Link_Web_HelperInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_link_web_helper = /** @type {((inputs?: Dialog_Link_Web_HelperInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Link_Web_HelperInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_link_web_helper(inputs)
	return en_dialog_link_web_helper(inputs)
});